import React from "react";
import {
  withStyles,
  makeStyles,
  Theme,
  createStyles,
  useTheme
} from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import { Info, Warning } from "@material-ui/icons";

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#212121",
    fontSize: theme.typography.pxToRem(12)
  }
}))(Tooltip);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      position: "absolute",
      top: "-26px"
    }
  })
);

export interface InfoTooltipProps {
  children?: any;
  type: "info" | "warning";
}

export default function InfoTooltip(props: InfoTooltipProps) {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <div>
      <HtmlTooltip
        className={classes.tooltip}
        placement={"top"}
        style={{
          right: props.type === "info" ? `20px` : "0",
          color:
            props.type === "info"
              ? `${theme.palette.grey["700"]}`
              : `${theme.palette.error.dark}`
        }}
        title={<React.Fragment>{props.children}</React.Fragment>}
      >
        <IconButton size={"small"} color="secondary">
          {props.type === "warning" ? <Warning /> : <Info />}
        </IconButton>
      </HtmlTooltip>
    </div>
  );
}
